/**
 * Model reprezentujący grupę usług w module Pakietów Abonamentowych (Care Plans).
 * Pozwala na logiczne agregowanie pojedynczych zabiegów medycznych.
 */
export class CarePlanServiceGroupType {

  /** Nazwa grupy usług wyświetlana w systemie konfiguracji pakietów.
   * Przykłady: "Badania laboratoryjne", "Konsultacje internistyczne".
   */
  public name: string;

  /** Globalnie unikalny identyfikator grupy (UUID). */
  public uuid: string;

  /** Rozszerzony opis przeznaczenia danej grupy usług.
   */
  public description: string;

  /** Identyfikator klienta, do którego przypisany jest ta grupa.
   * Gwarantuje, że każdy klient buduje i widzi wyłącznie własne grupy usług.
   */
  public vClientId: number;

}
